exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ftv-magneto--scrollable-scrollbar {\n  opacity: 0.8;\n}\n\n.ftv-magneto--scrollable-scrollbar:hover {\n  opacity: 1;\n}\n\n/** Hide scrollbars **/\n\n/* Chromium & Webkit */\n.ftv-magneto--scrollable-content::-webkit-scrollbar {\n  display: none;\n}\n\n/* Firefox */\n.ftv-magneto--scrollable-content {\n  scrollbar-width: none;\n\n  /* IE & Spartan (legacy) */\n  -ms-overflow-style: none;\n}\n", ""]);

// exports
